import React from 'react'
import Aux from '../../../hoc/Auxiliary'
import SectionHeading from '../../../components/Heading'

export const ContentEN = () => {
    return <Aux>
        <SectionHeading priority={1} text='Materials' />
        <p><b>PVC doors and windows: REHAU GENEO</b> - THE BEST SYSTEM DESERVED BY EVERYONE!</p>
        <p>GENEOis a leader in luxury housing. The system has been patented by REHAU, using a new technology, whereby the profile core is made by extrusion(casted in a matrix)from the high-tech RAU-FIPRO ® material. This innovative material formulation has been used for the first time in aircraft and Formula 1 industry, and now already in the construction of windows and doors too.<br />
        GENEO – the leader among the 86 mm profile depth systems! This is the perfect combination of seven-chambered frames with six-chambered wings and longitudinally built-in inner rubber seals.<br />
        Triple glazing: 4mm K glass + 4 mmwhite glass + 4mm Four Seasons glass 42mm<br />
        The glass units are sealed using two-component polysulfide sealants produced by
Kömmerling, Germany.<br />
Original Extension 45/80 Synego behind every wing from the side of the hinges – Preparation
for mounting internal blinds</p>
        <p><b>Window fittings:</b> <i>activPilot</i> is a latest-generation fitting system fromWinkhaus, combining most modern design and high functionality.</p>
        <p><b>Handles:</b> a model developed by the famous designer Pininfarina.</p>
        <p><b>Bricks:</b> Porotherm from Wienerberger.<br />
            A material with traditions but covering the contemporary requirements too</p>
        <p>Highest-class heat retention lagging and waterproofing.</p>
        <p>Railings of high strength laminated glass</p>
        <p><b>External door:</b> high-class armoured external doors</p>
    </Aux>
}

export default ContentEN



// WEBPACK FOOTER //
// ./src/routes/Materials/components/ContentEN.js